import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { applyTheme } from './app/applyTheme';
import { DEFAULT_THEME } from './content/themes';
import './styles/global.css';

// לפני הרינדור הראשון — אחרת הפריים הראשון מצויר בלי משתני הצבע.
applyTheme(DEFAULT_THEME);

const container = document.getElementById('root');
if (!container) throw new Error('חסר אלמנט #root ב-index.html');

createRoot(container).render(
    <StrictMode>
        <App />
    </StrictMode>,
);
